// extracted by mini-css-extract-plugin
module.exports = {"contentInnerWrapper":"Content_contentInnerWrapper__G8EKn","descriptionString":"Content_descriptionString__g1ZhN"};